import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { FormatNumber } from 'src/utils';

export default function NumberInput({
    variant = 'outlined',
    id,
    name,
    getValue,
    className,
    hiddenLabel,
    disabled,
    type,
    placeholder,
    required,
    size = 'small',
    readOnly,
    valueChange,
    label,
    autoFocus = false,
    ref,
    fractionSize = 0,
    onEnterPress = () => null,
    key,
    helperText,
    error = false,
}) {
    const [value, setValue] = React.useState('');
    const inputRef = React.useRef(null);
    const handleOnChange = (e) => {
        const formattedText = e.target.value.replace(/[^0-9]/g, '');
        setValue(formattedText);
        getValue && getValue(formattedText);
    };

    const handleKeyDown = (e) => {
        // Check if the pressed key is "Enter" (key code 13)
        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
            // Call the onEnterPress function if it's provided
            // alert('ok');
            onEnterPress ? onEnterPress() : inputRef.current.blur();
        }
    };

    return (
        <Box>
            <TextField
                size={size}
                fullWidth
                inputRef={ref}
                type={type}
                value={valueChange !== '' ? FormatNumber(valueChange ? valueChange : value, fractionSize, key) : ''}
                disabled={disabled}
                className={className}
                ref={inputRef}
                onKeyDown={handleKeyDown}
                required={required}
                name={name}
                placeholder={placeholder}
                readOnly={readOnly}
                label={label}
                hiddenLabel={hiddenLabel}
                autoFocus={autoFocus}
                onChange={handleOnChange}
                id={id}
                variant={variant}
                helperText={helperText}
                error={error}
            />
        </Box>
    );
}
